import axios, { AxiosError } from "axios";
import { IPublicClientApplication, AccountInfo } from "@azure/msal-browser";
import { getAccessToken } from "./authService";
import { hasDevModeAccess } from "../utils/devModeUtils";
import { CONFIG } from "../config";

export const apiClient = axios.create({
  baseURL: `${CONFIG.API_SERVER}/api`,
  headers: { "Content-Type": "application/json" },
});

let isInterceptorAttached = false;

export function attachTokenInterceptor(
  instance: IPublicClientApplication,
  account: AccountInfo
) {
  if (isInterceptorAttached) return;
  isInterceptorAttached = true;

  apiClient.interceptors.request.use(async (config) => {
    const token = await getAccessToken(instance, account);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (account && hasDevModeAccess(account)) {
      const impersonationEmail = localStorage.getItem("impersonationEmail");
      if (impersonationEmail) {
        config.headers["X-Override-Email"] = impersonationEmail;
      }
    }
    return config;
  });

  apiClient.interceptors.response.use(
    async (response) => {
      return response;
    },
    (error: AxiosError) => {
      let errorMessage = "Ocorreu um erro inesperado.";
      const errorCode = error.response?.status;
      let errorCodeNumber = errorCode ?? 500;
      if (error.response?.data) {
        errorMessage = error.response?.data as string;
      } else {
        if (errorCode === 403) {
          errorMessage = "Não tem permissão para aceder a esta página.";
        }
        if (errorCode === 404) {
          errorMessage = "O página não foi encontrada.";
        }
      }

      const params = new URLSearchParams({
        errorCode: String(errorCodeNumber),
        message: errorMessage,
      });
      if (window.location.pathname !== "/error") {
        window.location.assign(`/error?${params.toString()}`);
      }
      return Promise.reject(error);
    }
  );
}
